AFRAME.registerComponent("optional-alternative-to-not-hide", {});
